<template>
    <simple-modal :show="showNotificationModal" body-class="" max-width="max-w-7xl" v-if="showNotificationModal">
        <div class="p-4 rounded-t-md bg-brand text-white" slot="title">
            <div class="leading-6 font-normal">
                <p class="text-xs text-gray-200">
                    <span class="inline-flex bg-white rounded px-1 text-red-900 font-extrabold uppercase mr-2 leading-5">
                        {{ notificationInFocus.category }}
                    </span>
                    <span>
                        {{ notificationInFocus.published_at | datetime }}
                    </span>
                </p>
                <p class="text-sm font-medium text-white mt-1">{{ notificationInFocus.summary }}</p>
                <!-- Tags If applicable-->
                <div v-if="notificationInFocus.tags && notificationInFocus.tags.length > 0" class="space-x-2">
                    <div v-for="tag in notificationInFocus.tags"
                         class="text-white inline-flex items-center text-xs font-medium">
                        <svg width="8" height="8">
                            <circle cx="3" cy="4" r="3" fill="currentColor"></circle>
                        </svg>
                        <span class="pb-0.5">{{ tag | capitalize }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Main Details Section -->
        <div v-if="isLoadingData" class="relative p-12">
            <loading-indicator></loading-indicator>
        </div>

        <div v-else class="my-4 prose min-w-full overflow-y-scroll"
             :class="[currentBrowser() != 'chrome' ? 'scrollbar-thin' : '']"
             style="max-height: 60vh">
            <div id="notification-detail" class="p-4" v-html="notificationInFocus.more_detail"></div>
        </div>

        <div v-if="requiresAcknowledgement && !isLoadingData"
             class="my-6 flex justify-center bg-gray-100 rounded-md text-black font-medium text-sm p-3">
            <checkbox v-model="acknowledge" :label="acknowledgementConfirmationText"></checkbox>
        </div>
        <div class="py-6 flex justify-around" v-if="!requiresAcknowledgement">
            <button type="button" @click.prevent="closeModal" :disabled="requiresAcknowledgement"
                    class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:border-indigo-700 focus:ring focus:ring-indigo-400 transition ease-in-out duration-300 sm:text-sm sm:leading-5">
                {{ this.notificationsArray.length > 1 ? "Next" : "Close" }}
            </button>
        </div>
    </simple-modal>
</template>

<script>
export default {
    name: "SystemNotificationModal",

    props: {
        systemNotificationId: {
            type: String,
            default: null
        },
        notificationsArray: {
            type: Array,
            required: false
        }
    },

    data () {
        return {
            mutableNotificationsArray: this.notificationsArray,
            showNotificationModal: false,
            acknowledge: false,
            isLoadingData: false,
        };
    },

    watch: {
        notificationsArray (newArray) {
            this.mutableNotificationsArray = newArray;
        },
        notificationInFocus (newFocusedNotification) {
            this.isLoadingData = true;
            axios.get("/system-notifications/" + newFocusedNotification.id + "/more-detail")
            .then(response => {
                let index = this.mutableNotificationsArray.findIndex(notification => notification.pivot.id = newFocusedNotification.pivot.id);
                this.mutableNotificationsArray[index].more_detail = response.data;
                this.isLoadingData = false;
            }).catch(errors => {
                toastr.error("Error loading data for this notification");
            });
        },
        acknowledge (newVal) {
            if (newVal) {
                App.patch("/system-notifications/" + this.notificationInFocus.pivot.id + "/update", new AppForm({
                    acknowledged: true
                })).then(response => {
                    let index = this.mutableNotificationsArray.findIndex(n => n.pivot.id === response.pivot.id);
                    this.mutableNotificationsArray[index].pivot.status = "acknowledged";
                    Bus.$emit("notification-updated", response);
                }).catch(errors => {
                    toastr.error("Could not mark notification as acknowledged");
                });
            }
        }
    },
    computed: {
        notificationInFocus () {
            return this.notificationsArray[0];
        },
        requiresAcknowledgement () {
            return this.notificationInFocus.pivot.status == "new" && this.notificationInFocus.requires_acknowledgement == 1;
        },
        acknowledgementConfirmationText () {
            let category = this.notificationInFocus.category;
            let text = "I confirm that I've read this ";
            switch (category) {
                case "bug":
                    return text += "bug report";
                case "feature":
                    return text += "feature update";
                default:
                    return text += category;
            }
        }
    },

    methods: {
        toggleNotificationModal () {
            this.showNotificationModal = !this.showNotificationModal;
        },
        closeModal () {
            if (this.notificationInFocus.pivot.status == "new") {
                Bus.$emit("mark-as-seen", this.notificationInFocus);
            }
            if (this.notificationsArray.length > 1) {
                // scroll to the top of the notification
                document.getElementById("notification-detail").scrollIntoView();
                // If there are more notifications in the array the remove the first notification from the array
                // Since the current index evaluation is always 0 the next notification in position 0 will display
                this.notificationsArray.shift();
            } else {
                this.showNotificationModal = false;
            }
            // Reset checkbox
            this.acknowledge = false;
        },
    }
};
</script>

<style scoped>
/* width */
.overflow-y-scroll::-webkit-scrollbar {
    width: 5px;
}

/* Track */
.overflow-y-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
.overflow-y-scroll::-webkit-scrollbar-thumb {
    background: #adadad;
}

/* Handle on hover */
.overflow-y-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
}
</style>
